<script setup>
import Datatable from '@/components/Shared/Table/Datatable.vue';
import {onBeforeMount, inject, ref} from 'vue';
import moment from 'moment';

const trans = inject('trans');

const props = defineProps({
  pagination: {
    type: Object,
    default: null,
  },
  services: {
    type: Array,
    required: true,
  },
  filters: {
    type: Object,
    default: () => ({}),
  },
  isTeam: {
    type: Boolean,
    required: true,
  },
});
const headers = [
  {text: trans('__JSON__.Date purchased'), value: 'datePurchased', align: 'start'},
  {text: trans('__JSON__.Description'), value: 'description', align: 'start'},
  {text: trans('__JSON__.Available hours/flows'), value: 'remainingHoursOrFlows', align: 'start'},
  {text: trans('__JSON__.Spent hours/flows'), value: 'spentHoursOrFlows', align: 'start'},
  {text: trans('__JSON__.Status'), value: 'status', align: 'start'},
  {text: '', value: 'action', align: 'start'},
];

onBeforeMount(() => {
  if (props.isTeam) {
    let lastHeader = headers.pop();
    headers.push({text: trans('__JSON__.Ordered by'), value: 'orderedBy', align: 'start'});
    headers.push(lastHeader);
  }
});

const filters = ref(props.filters);
</script>

<template>
  <datatable :filters="filters" :headers="headers" :items="services" :loading="false" :pagination="pagination">
    <template #item-date-purchased="{ item }">
      {{ moment(item.datePurchased).format('DD/MM/YYYY') }}
    </template>
    <template #item-remaining-hours-or-flows="{ item }">
      <div v-if="item.type === 'hours'">
        {{ item.remainingHours }}
      </div>
      <div v-else>
        {{ item.remainingFlows }}
      </div>
    </template>
    <template #item-spent-hours-or-flows="{ item }">
      <div v-if="item.type === 'hours'">
        {{ item.spentHours }}
      </div>
      <div v-else>
        {{ item.spentFlows }}
      </div>
    </template>
    <template #item-action="{ item }">
      <inertia-link :href="route('dashboard.support.services.purchases.show', item.id)" class="tile-button">
        <svg class="icon">
          <use xlink:href="#eye-icon"></use>
        </svg>
      </inertia-link>
    </template>
    <template #item-description="{ item }">
      <inertia-link :href="route('dashboard.support.services.purchases.show', item.id)" class="link">
        {{ item.description }}
      </inertia-link>
    </template>
  </datatable>
</template>